import React from "react";
import { twMerge } from "tailwind-merge";
import { Separator } from "../generic/Separator";

interface Props {
  className?: string;
  separatorClassName?: string;
  children: React.ReactNode;
}

export const CardWithSection = ({
  className,
  separatorClassName,
  children,
}: Props) => {
  // Filtering to make sure TypeScript doesn't complain about key property not being present. Shouldn't make a difference in the actual rendering.
  const childrenArray = React.Children.toArray(children).filter(
    React.isValidElement,
  );

  const separator = <Separator />;

  return (
    <div
      className={twMerge(
        "border-theme-outline-variant flex flex-col gap-y-7 rounded-md border px-5 py-7",
        className,
      )}
    >
      {childrenArray.map((child, idx) => (
        <React.Fragment key={child.key || idx}>
          {child}
          {idx < childrenArray.length - 1 && separator}
        </React.Fragment>
      ))}
    </div>
  );
};
